export default {
  props: {
    apiModel: {
      type: String,
      required: true
    },
  },
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
};
